import type { SchemaColumn } from '@cli-types/core-engine/schema.js'
import { renderImageElementLayoutTemplate } from '@next-adapter/templates/renderers/generators/columns/column-defs/generate-image-element.js'

export function generateImageElement(column: SchemaColumn): string {
  return renderImageElementLayoutTemplate({ columnHeader: column.header })
}
